import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  additionalInfo: {
    color: palette.shades[700]
  },
  loaderWrapper: {
    marginTop: '180px',
    textAlign: 'center',
    padding: '0 36px'
  },
  controllers: {
    '& .MuiButton-root + .MuiButton-root': {
      marginLeft: '16px'
    }
  }
});
export default useStyles;